export interface version {
  id: string;
  version: string;
  type: string;
  created: number;
  modified: number;
  description: string;
  md5: string;
  file_name: string;
  public_path?: string;
}

export const decode_string = (base64String: string) =>
  window.atob(base64String);

export const tabs: {
  key: string;
  value: string;
  ico: string;
  be_mapping: string | undefined;
  also_matches?: string[];
  // Extra upload choices when one chip covers several backend types.
  upload_types?: { value: string; be_mapping: string }[];
  route_name?: string;
}[] = [
  {
    key: "explorer",
    value: "Explorer",
    ico: "fa-solid fa-folder",
    be_mapping: "explore",
    route_name: "VersionExplorer",
  },
  {
    key: "process",
    value: "Tiến trình",
    ico: "fa-solid fa-bolt-lightning",
    be_mapping: "process",
    route_name: "VersionProcess",
  },
  {
    key: "application",
    value: "Ứng dụng",
    ico: "fa-solid fa-circle-play",
    be_mapping: "app_install",
    route_name: "VersionApplication",
  },
  {
    key: "opened_port",
    value: "Cổng mở",
    ico: "fa-solid fa-door-open",
    be_mapping: "open_port",
    route_name: "VersionOpenedPort",
  },
  {
    key: "keylogger",
    value: "Ghi phím",
    ico: "fa-solid fa-keyboard",
    be_mapping: "key_logger",
    route_name: "VersionKeylogger",
  },
  {
    key: "screenshot",
    value: "Chụp màn hình",
    ico: "fa-solid fa-camera",
    be_mapping: "screenshot",
    route_name: "VersionScreenshot",
  },
  {
    key: "system_cmd",
    value: "Lệnh hệ thống",
    ico: "fa-solid fa-gear",
    be_mapping: "system_cmd",
    route_name: "VersionSystemCmd",
  },
  {
    key: "bypass_amsi",
    value: "PowerShell — BypassAMSI",
    ico: "fa-solid fa-terminal",
    be_mapping: "bypass-amsi",
  },
  {
    key: "chat_history",
    value: "Lịch sử trò chuyện",
    ico: "fa-solid fa-comments",
    be_mapping: "chat_history",
    route_name: "VersionChatHistory",
  },
  {
    key: "last_activity",
    value: "Hoạt động gần đây",
    ico: "fa-solid fa-clock-rotate-left",
    be_mapping: "last_activity",
    route_name: "VersionLastActivity",
  },
  {
    key: "recon",
    value: "Thu thập thông tin",
    ico: "fa-solid fa-magnifying-glass",
    be_mapping: "recon",
    route_name: "VersionRecon",
  },
  {
    key: "elevate",
    value: "Nâng quyền",
    ico: "fa-solid fa-arrow-up-from-bracket",
    be_mapping: "elevate",
    route_name: "VersionElevate",
  },
  {
    key: "base_build",
    value: "Base build",
    ico: "fa-solid fa-box",
    be_mapping: "base_build",
    route_name: "VersionBaseBuild",
  },
  {
    key: "inject",
    value: "Tiêm mã độc - BOF Reflective",
    ico: "fa-solid fa-syringe",
    be_mapping: "bof_reflective",
  },
  {
    key: "bof_hollowing",
    value: "BOF Process Hollowing",
    ico: "fa-solid fa-syringe",
    be_mapping: "bof_hollowing",
  },
  {
    key: "rollback_process",
    value: "Rollback tiến trình",
    ico: "fa-solid fa-rotate-left",
    be_mapping: "rollback-process",
  },
  {
    key: "dll_hijack_rollback",
    value: "Rollback DLL Hijack",
    ico: "fa-solid fa-rotate-left",
    be_mapping: "find-dml-dll-hijack-rollback",
  },
  {
    key: "com_hijack_rollback",
    value: "Rollback COM Hijack",
    ico: "fa-solid fa-rotate-left",
    be_mapping: "find-dml-com-hijack-rollback",
  },
  {
    key: "lolbin",
    value: "LOLBin",
    ico: "fa-solid fa-terminal",
    be_mapping: "lol_bin",
  },
  // Backend-supported LoLBin version buckets (names kept verbatim, typos included).
  {
    key: "lolbin_bitsadmin",
    value: "LOLBin — Bitsadmin",
    ico: "fa-solid fa-terminal",
    be_mapping: "bitsadmin",
  },
  {
    key: "lolbin_mshata",
    value: "LOLBin — Mshta",
    ico: "fa-solid fa-terminal",
    be_mapping: "mshata",
  },
  {
    key: "lolbin_certuil",
    value: "LOLBin — Certutil",
    ico: "fa-solid fa-terminal",
    be_mapping: "certuil",
  },
  {
    key: "lolbin_regsvr32",
    value: "LOLBin — Regsvr32",
    ico: "fa-solid fa-terminal",
    be_mapping: "regsvr32",
  },
  {
    key: "dump_credential",
    value: "Trích xuất mật khẩu",
    ico: "fa-solid fa-key",
    be_mapping: "dump-credential",
    route_name: "VersionDumpCredential",
  },
  {
    key: "browser_credential",
    value: "Credential trình duyệt",
    ico: "fa-solid fa-lock",
    be_mapping: "browser-credential",
    route_name: "VersionBrowserCredential",
  },
  {
    key: "record",
    value: "Bản ghi",
    ico: "fa-solid fa-video",
    be_mapping: "record",
    route_name: "VersionRecord",
  },
  {
    key: "find_dll_missing",
    value: "Find DLL Missing",
    ico: "fa-solid fa-magnifying-glass",
    be_mapping: "find-dll-missing",
  },
  {
    key: "find_dll_missing_scan",
    value: "Find DLL Missing — Scan",
    ico: "fa-solid fa-magnifying-glass",
    be_mapping: "find-dll-missing-scan",
  },
  {
    key: "dll_hijack",
    value: "DLL Hijack",
    ico: "fa-solid fa-link",
    be_mapping: "dll-hijack",
  },
  {
    key: "com_hijack",
    value: "COM Hijack",
    ico: "fa-solid fa-link",
    be_mapping: "com-hijack",
  },
  {
    key: "net_scan",
    value: "Net Scan",
    ico: "fa-solid fa-network-wired",
    be_mapping: "net_scan",
  },
  {
    key: "kill_av",
    value: "Kill AV",
    ico: "fa-solid fa-shield-halved",
    be_mapping: "kill_av",
    // Sibling types stored per AV product; one chip filters all of them,
    // and uploading any of the four types keeps this chip selected.
    also_matches: ["kill_av__win_def", "kill_av_bit", "kill_av_kas"],
    upload_types: [
      { value: "Kill AV", be_mapping: "kill_av" },
      { value: "Kill AV — Windows Defender", be_mapping: "kill_av__win_def" },
      { value: "Kill AV — Bitdefender", be_mapping: "kill_av_bit" },
      { value: "Kill AV — Kaspersky", be_mapping: "kill_av_kas" },
    ],
  },
  {
    key: "interactive_terminal",
    value: "Interactive Terminal",
    ico: "fa-solid fa-terminal",
    be_mapping: "interactive_terminal",
  },
];
